export const getCookiesMap = (): Map<string, string> => {
    const cookiesMap = new Map<string, string>();
    const cookieString = document.cookie;
    if ( !cookieString ) {
        return cookiesMap;
    }

    cookieString.split( ';' ).forEach( (cookie ) => {
        const separatorIndex = cookie.indexOf( '=' );
        if ( separatorIndex == -1 ) {
            return;
        }
        const name = cookie.substring( 0, separatorIndex ).trim();
        if ( !name ) {
            return;
        }
        const rawValue = cookie.substring( separatorIndex + 1 );
        let value = rawValue;
        try {
            value = decodeURIComponent( rawValue );
        } catch ( e ) {
            console.warn( `Failed to decode cookie value ${rawValue} for ${name}`, e );
        }

        cookiesMap.set( name, value );
    });

    return cookiesMap;
};
